export default Object.freeze({
  VIDEO: "video",
  CALL: "call",
  EMAIL: "email",
  AMBASSADOR: "ambassador",
  PROSPECT: "prospect",
});
